class SectionPromoBar extends HTMLElement {
  constructor() {
    super();
    this.initFunction();
  }

  initFunction() {
    window.loadSwiper.then(({ Swiper, Autoplay, Navigation }) => {
      const swiperParams = {
        modules: [Autoplay, Navigation],
        slidesPerView: 1,
        speed: 500,
        loop: true,
        autoplay: { delay: 2000, disableOnInteraction: false },
        navigation: {
          nextEl: this.querySelector("[data-swiper-next]"),
          prevEl: this.querySelector("[data-swiper-prev]"),
        },
      };

      const swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }
}

if (!customElements.get("section-promo-bar")) {
  customElements.define("section-promo-bar", SectionPromoBar);
}
